import { gql } from '@apollo/client';

// TODO: Unify with other collection query
export const GET_STAY_INFORMATION_COLLECTION_QUERY_BY_PARENT_ID = gql`
  fragment CommonStayInformationFieldsForCollection on StayInformation {
    id
    bannerImage {
      id
      url
      formats
    }
    title
    locale
    hidden
    size
    externalBannerImage
  }

  query GetStayInformationCollectionByParentId($parentStayInfo: ID) {
    stayInformations(where: { parentStayInfo: $parentStayInfo }) {
      appSortOrder
      ...CommonStayInformationFieldsForCollection
      localizations {
        ...CommonStayInformationFieldsForCollection
      }
    }
  }
`;
